"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /* eslint-disable */

// import { WidthProvider, Responsive } from "react-grid-layout";
//'react-grid-layout';


var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _ResponsiveReactGridLayout = require("./ReactGridLayout/lib/ResponsiveReactGridLayout");

var _ResponsiveReactGridLayout2 = _interopRequireDefault(_ResponsiveReactGridLayout);

var _WidthProvider = require("./ReactGridLayout/lib/components/WidthProvider");

var _WidthProvider2 = _interopRequireDefault(_WidthProvider);

require("./LayoutReader.css");

require("./react-grid-layout.css");

require("./react-resizable.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//'react-grid-layout';

var ResponsiveReactGridLayout = (0, _WidthProvider2.default)(_ResponsiveReactGridLayout2.default);

/**
 * Layout Reader
 * This component takes a spec id and will load the JSON configuration of that spec
 * Optionally a sysdata object may be passed containing a callBacks array
 * @param {number} id - Id of the spec data that is being passed
 * @param {object} sysdata - Data object for passing callbacks and dynamic string
 * @param {object} specData - Data returned from the server about the spec
 */
var LayoutReaderCore = (_temp2 = _class = function (_Component) {
  _inherits(LayoutReaderCore, _Component);

  function LayoutReaderCore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LayoutReaderCore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LayoutReaderCore.__proto__ || Object.getPrototypeOf(LayoutReaderCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentBreakPoint: "lg",
      layout: null
    }, _this.handleResize = function () {
      var bp = "lg";
      if (!_this.state.layout) {
        _this.setState({ currentBreakPoint: bp });
        return;
      }
      var breakPoints = _this.state.layout.breakPoints;
      var lg = breakPoints.lg,
          md = breakPoints.md,
          sm = breakPoints.sm,
          xs = breakPoints.xs;
      var id = _this.props.id;


      var elm = document.querySelector(".react-grid-layout.layout-" + id);
      var curWidth = getComputedStyle(elm).getPropertyValue("width");
      var width = _this.getNumberfromPixels(curWidth);

      switch (true) {
        case width > lg:
          bp = "lg";
          break;
        case width <= lg && width > md || width == md:
          bp = "md";
          break;
        case width < md && width > sm || width == sm:
          bp = "sm";
          break;
        case width < sm && width > xs || width == xs:
          bp = "xs";
          break;
        case width < xs:
          bp = "xxs";
          break;
        default:
          bp = "lg";
      }

      _this.setState({ currentBreakPoint: bp });
    }, _this.getNumberfromPixels = function (pixelVal) {
      return parseInt(pixelVal.match(/\d+/), 10);
    }, _this.getChildId = function (c) {
      return c.type + "_" + c.id.split("-").join("_");
    }, _this.renderBlockChildren = function (children) {
      return children.map(function (c) {
        if (_this.props.components[c.type]) {
          var DynamicComponent = _this.props.components[c.type];
          return _react2.default.createElement(
            "div",
            { className: "d-flex w-100", key: c.id, style: Object.assign({}, c.alignment) },
            _react2.default.createElement(DynamicComponent, Object.assign({
              id: _this.getChildId(c)
            }, c.props, {
              sysdata: _this.props.sysdata
            }, _this.props[_this.getChildId(c)]))
          );
        } else {
          console.error("Component", c.type, "has not been loaded into this version of LayoutReader. Add the component to LayoutReader's Shared.js file and export that to bit and update this application's version of LayoutReader");
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LayoutReaderCore, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener("resize", this.handleResize);
      this.setState({ layout: this.props.specData });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          currentBreakPoint = _state.currentBreakPoint,
          layout = _state.layout;
      var id = this.props.id;


      if (layout) {
        var gridParams = layout.gridParams,
            _layout$vGutter = layout.vGutter,
            vGutter = _layout$vGutter === undefined ? 10 : _layout$vGutter,
            _layout$hGutter = layout.hGutter,
            hGutter = _layout$hGutter === undefined ? 10 : _layout$hGutter;


        return _react2.default.createElement(
          "div",
          { style: (0, _get2.default)(layout, "pageParams", {}).style },
          _react2.default.createElement(
            ResponsiveReactGridLayout,
            {
              style: (0, _get2.default)(layout, "pageContentParams", {}).style,
              breakpoints: layout.breakPoints,
              cols: layout.cols,
              isResizable: false,
              isDraggable: false,
              margin: [parseFloat(hGutter), parseFloat(vGutter)],
              className: "layout layout-" + id,
              layouts: layout.config,
              rowHeight: 30
            },
            layout.config[currentBreakPoint].map(function (block) {
              return _react2.default.createElement(
                "div",
                Object.assign({
                  role: "presentation",
                  style: gridParams[block.i] ? Object.assign({}, gridParams[block.i].styles) : {},
                  className: "d-flex",
                  id: block.i,
                  key: block.i
                }, _this2.props[block.i]),
                layout.blockChildren[block.i] && _this2.renderBlockChildren(layout.blockChildren[block.i])
              );
            })
          )
        );
      }
      return null;
    }
  }]);

  return LayoutReaderCore;
}(_react.Component), _class.defaultProps = {
  layout: null,
  sysdata: {}
}, _temp2);
exports.default = LayoutReaderCore;


LayoutReaderCore.propTypes = {
  components: _propTypes2.default.shape().isRequired,
  sysdata: _propTypes2.default.shape({}),
  specData: _propTypes2.default.shape().isRequired,
  id: _propTypes2.default.number.isRequired,
  layout: _propTypes2.default.shape({
    config: _propTypes2.default.shape({}),
    breakPoints: _propTypes2.default.shape({}),
    currentBreakPoint: _propTypes2.default.string,
    gridParams: _propTypes2.default.shape({})
  })
};

//# sourceMappingURL=LayoutReaderCore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader-core/dist/LayoutReaderCore.js
// module id = 654
// module chunks = 0